import { createLogWriter } from "@roarr/browser-log-writer";

window.ROARR = window.ROARR ?? {};
window.ROARR.write = createLogWriter();
